module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-smile-svgrepo-com.7f869aa9.svg";